import { render } from "./Heart.vue?vue&type=template&id=90faf190&ts=true"
import script from "./Heart.vue?vue&type=script&lang=ts"
export * from "./Heart.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__